export default () => ({
    show: false,
    popupStore: null,

    init () {
        const popupId = this.$root.id

        if (!popupId) {
            return;
        }

        this.popupStore = this.$store.popup[popupId];

        this.$watch(`$store.popup['${popupId}'].show`, (value) => {
            this.show = value
        })
    },

    closeButtonHandler () {
        this.popupStore.show = false
    }
})